import { lazy } from 'solid-js'
import { messages } from '../../pages/request-listing-setup-page/request-listing-setup-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/request-listing-setup-page/request-listing-setup-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/request-listing-setup',
    titleMessage: messages.titleMessage,
}
